<router-outlet></router-outlet>
<!--
  Single toaster. It renders one <ol> per position present in the toast store,
  so per-toast `position` (e.g. bottom-right for notification toasts) is routed
  automatically. Default position top-center covers app-wide system toasts that
  pass no position. Do NOT add a second toaster — each toaster renders EVERY
  position found in the store, which duplicates positioned toasts.
-->
<ngx-sonner-toaster
  position="top-center"
  [theme]="theme()"
  [toastOptions]="{
    classes: {
      toast: 'dark:bg-zinc-900 dark:border dark:border-zinc-700',
    }
  }"
/>
